import gql from 'graphql-tag';

export default gql`
  fragment blastengineAutomaticMailSendMailClickProspectActivityFragment on BlastengineAutomaticMailSendMailClickProspectActivity {
    id
    automaticMailUrl {
      id
      url
    }
    automaticMailSendShortUrl {
      id
      urlPlaceholder
    }
    automaticMailSend {
      id
      step {
        name
      }
    }
  }
`;
